/**
 * Normalizes multiple_investments for the cap table ledger cell (row 28).
 * SUM_FROM_ACCRUED_LEDGER expects an array; the Security model default is now [].
 * Legacy rows may still store {"investments": [{date, shares}]} — unwrap those for reads.
 * When has_multiple_investments is false, always use [] so eager IF-branch evaluation cannot throw.
 */
const normalizeMultipleInvestmentsLedger = (
  multipleInvestments: unknown,
  hasMultipleInvestments?: boolean | null
): unknown[] => {
  if (!hasMultipleInvestments) {
    return [];
  }

  if (Array.isArray(multipleInvestments)) {
    return multipleInvestments;
  }

  if (
    multipleInvestments !== null &&
    typeof multipleInvestments === 'object' &&
    Array.isArray((multipleInvestments as { investments?: unknown }).investments)
  ) {
    return (multipleInvestments as { investments: unknown[] }).investments;
  }

  return [];
};

export default normalizeMultipleInvestmentsLedger;
